"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M43.705,10.01a5.1,5.1,0,0,1-3.668-1.236A5.088,5.088,0,0,1,38.7,5.015a5.04,5.04,0,0,1,1.337-3.769A5.017,5.017,0,0,1,43.705,0a5.1,5.1,0,0,1,3.668,1.246A5.113,5.113,0,0,1,48.71,5.015a5,5,0,0,1-1.347,3.769A5,5,0,0,1,43.705,10.01Zm0-8.874a4,4,0,0,0-2.874.925,4.021,4.021,0,0,0-.985,2.955,3.944,3.944,0,0,0,.985,2.945,3.941,3.941,0,0,0,2.874.915,4.07,4.07,0,0,0,2.884-.915,3.981,3.981,0,0,0,.995-2.945c0-2.613-1.276-3.879-3.879-3.879Z",
    transform: "translate(-23.81 10)",
    fill: "#fff"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M17.216,129.2H.573A.573.573,0,0,1,0,128.626v-1.668a5.5,5.5,0,0,1,1.437-3.93,6.155,6.155,0,0,1,4.4-1.628h6.1a5.917,5.917,0,0,1,4.4,1.628,5.32,5.32,0,0,1,1.437,3.93v1.668a.563.563,0,0,1-.563.573Zm-16.07-1.136H16.653v-1.1a4.426,4.426,0,0,0-1.126-3.146,4.98,4.98,0,0,0-3.588-1.286h-6.1a4.77,4.77,0,0,0-3.578,1.276,4.211,4.211,0,0,0-1.116,3.146Z",
    transform: "translate(11 -99.199)",
    fill: "#fff"
  })]
});

var PriorityUser = function PriorityUser(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '8 8.5 23.5 23.5';
  }

  if (!mainDimension) {
    mainDimension = 'y';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "PriorityUser-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = PriorityUser;
exports["default"] = _default;

//# sourceMappingURL=index.js.map